module.exports = __webpack_public_path__ + "img/L_318_324.47407426.png";